import { produce } from 'immer';
import { memoize } from 'lodash-es';
import { Theme } from 'theme';

export const PendingSessionsModalSize: (globalTheme: Theme) => Theme = memoize(
  (globalTheme) =>
    produce(globalTheme, (draft) => {
      draft.modal.content.mobile.width = 'min(560px, 100%)';
      draft.modal.content.tablet.width = draft.modal.content.desktop.width =
        '560px';

      draft.modal.content.mobile.top = draft.modal.content.tablet.top = 'unset';
      draft.modal.content.mobile.bottom = draft.modal.content.tablet.bottom =
        '0';
      draft.modal.content.mobile.borderRadius =
        draft.modal.content.tablet.borderRadius = '10px 10px 0 0';

      draft.modal.content.desktop.top = '50%';
      draft.modal.content.desktop.bottom = 'unset';
      draft.modal.content.desktop.transform = 'translateY(-50%)';
    }),
);
